import styled from 'styled-components';

export const GroupsContainer = styled.div`
  overflow-y: auto;
  min-height: 0;
`;

export const FooterContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => theme.spacing(1)};

  & > ul {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing(2)};
    border-bottom: none;

    & > * {
      flex: 1;
      width: 0;
    }
  }
`;
